export enum ECMPWindow {
    GDPR            = 1,
    CONFIGURATION   = 2,
    INSIST          = 3,
}
